module.exports = __webpack_public_path__ + "img/reference-aha-vorarlberg.7f26239b.jpg";